// src/pages/VehiclesManagement.js

import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';

function VehiclesManagement() {
  const { userProfile } = useAuth();
  const [vehicles, setVehicles] = useState([]);
  const [newVehiclePlate, setNewVehiclePlate] = useState('');
  const [newVehicleModel, setNewVehicleModel] = useState('');
  const [editingVehicleId, setEditingVehicleId] = useState(null);
  const [editingVehiclePlate, setEditingVehiclePlate] = useState('');
  const [editingVehicleModel, setEditingVehicleModel] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const vehiclesCollectionRef = collection(db, 'vehiculos'); // Colección 'vehiculos'

  const getVehicles = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await getDocs(vehiclesCollectionRef);
      setVehicles(data.docs.map(doc => ({ ...doc.data(), id: doc.id })));
    } catch (err) {
      console.error("Error al obtener vehículos:", err.message);
      setError("No se pudieron cargar los vehículos.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getVehicles();
  }, []);

  const addVehicle = async (e) => {
    e.preventDefault();
    setError('');
    if (!newVehiclePlate || !newVehicleModel) {
      setError('Placa y modelo son requeridos para añadir un vehículo.');
      return;
    }
    try {
      await addDoc(vehiclesCollectionRef, {
        plate: newVehiclePlate.toUpperCase(), // Guardar placa en mayúsculas
        model: newVehicleModel,
        createdAt: new Date().toISOString(),
      });
      setNewVehiclePlate('');
      setNewVehicleModel('');
      getVehicles();
      alert('Vehículo añadido exitosamente!');
    } catch (err) {
      console.error("Error al añadir vehículo:", err.message);
      setError("No se pudo añadir el vehículo.");
    }
  };

  const startEditing = (vehicle) => {
    setEditingVehicleId(vehicle.id);
    setEditingVehiclePlate(vehicle.plate);
    setEditingVehicleModel(vehicle.model);
  };

  const updateVehicle = async (id) => {
    setError('');
    if (!editingVehiclePlate || !editingVehicleModel) {
      setError('Placa y modelo son requeridos para actualizar el vehículo.');
      return;
    }
    const vehicleDoc = doc(db, 'vehiculos', id);
    try {
      await updateDoc(vehicleDoc, {
        plate: editingVehiclePlate.toUpperCase(), // Guardar placa en mayúsculas
        model: editingVehicleModel,
        updatedAt: new Date().toISOString(),
      });
      setEditingVehicleId(null);
      setEditingVehiclePlate('');
      setEditingVehicleModel('');
      getVehicles();
      alert('Vehículo actualizado exitosamente!');
    } catch (err) {
      console.error("Error al actualizar vehículo:", err.message);
      setError("No se pudo actualizar el vehículo.");
    }
  };

  const deleteVehicle = async (id) => {
    setError('');
    if (window.confirm('¿Estás seguro de que quieres eliminar este vehículo?')) {
      const vehicleDoc = doc(db, 'vehiculos', id);
      try {
        await deleteDoc(vehicleDoc);
        getVehicles();
        alert('Vehículo eliminado exitosamente!');
      } catch (err) {
        console.error("Error al eliminar vehículo:", err.message);
        setError("No se pudo eliminar el vehículo.");
      }
    }
  };

  // Roles que pueden gestionar vehículos: SOLO Administrador
  const canManageVehicles = userProfile && userProfile.rol === 'Administrador';

  if (!canManageVehicles) {
    return (
      <div style={{ textAlign: 'center', padding: '50px', color: 'red' }} className="app-content-container">
        <h3>Acceso Denegado</h3>
        <p>No tienes los permisos necesarios para gestionar vehículos.</p>
      </div>
    );
  }

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '50px' }} className="app-content-container">Cargando vehículos...</div>;
  }

  return (
    <div className="app-content-container">
      <h2 style={{ textAlign: 'center' }}>Gestión de Vehículos</h2>

      {error && <p className="login-error">{error}</p>}

      <h3>Añadir Nuevo Vehículo</h3>
      <form onSubmit={addVehicle} style={{ display: 'flex', gap: '10px', marginBottom: '30px' }}>
        <input
          type="text"
          placeholder="Placa del Vehículo"
          value={newVehiclePlate}
          onChange={(e) => setNewVehiclePlate(e.target.value)}
          style={{ flex: 1, padding: '8px', border: '1px solid var(--border-color)', borderRadius: '4px' }}
          required
        />
        <input
          type="text"
          placeholder="Modelo del Vehículo"
          value={newVehicleModel}
          onChange={(e) => setNewVehicleModel(e.target.value)}
          style={{ flex: 1, padding: '8px', border: '1px solid var(--border-color)', borderRadius: '4px' }}
          required
        />
        <button type="submit" style={{ backgroundColor: 'var(--secondary-blue)', color: 'white' }}>
          Añadir Vehículo
        </button>
      </form>

      <h3>Lista de Vehículos</h3>
      {vehicles.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#666' }}>No hay vehículos registrados.</p>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Placa</th>
              <th>Modelo</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {vehicles.map(vehicle => (
              <tr key={vehicle.id}>
                <td>
                  {editingVehicleId === vehicle.id ? (
                    <input
                      type="text"
                      value={editingVehiclePlate}
                      onChange={(e) => setEditingVehiclePlate(e.target.value)}
                      style={{ width: '100%', padding: '5px' }}
                    />
                  ) : (
                    vehicle.plate
                  )}
                </td>
                <td>
                  {editingVehicleId === vehicle.id ? (
                    <input
                      type="text"
                      value={editingVehicleModel}
                      onChange={(e) => setEditingVehicleModel(e.target.value)}
                      style={{ width: '100%', padding: '5px' }}
                    />
                  ) : (
                    vehicle.model
                  )}
                </td>
                <td className="action-buttons">
                  {editingVehicleId === vehicle.id ? (
                    <>
                      <button onClick={() => updateVehicle(vehicle.id)} style={{ backgroundColor: 'var(--secondary-blue)', color: 'white', padding: '6px 12px' }}>Guardar</button>
                      <button onClick={() => setEditingVehicleId(null)} style={{ backgroundColor: 'var(--primary-red)', color: 'white', padding: '6px 12px' }}>Cancelar</button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => startEditing(vehicle)} style={{ backgroundColor: '#ffc107', color: 'white', padding: '6px 12px' }}>Editar</button>
                      <button onClick={() => deleteVehicle(vehicle.id)} style={{ backgroundColor: 'var(--primary-red)', color: 'white', padding: '6px 12px' }}>Eliminar</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default VehiclesManagement;